module.exports = __webpack_public_path__ + "static/media/medkit.2f554867.jpeg";